import {useEffect} from 'react';

import {Navigate, useLocation} from 'react-router-dom';

import {Grid} from '@mui/material';

import CopyrightLink from '../../components/CopyrightLink/CopyrightLink';
import {CompatibleTalentsSection} from '../../features/b2bResults/CompatibleTalentsSection/CompatibleTalentsSection';
import {CultureDimensionsSection} from '../../features/b2bResults/CultureDimensionsSection/CultureDimensionsSection';
import {HubspotCalendarSection} from '../../features/b2bResults/HubspotCalendarSection/HubspotCalendarSection';
import {HubspotRegistrationFormSection} from '../../features/b2bResults/HubspotRegistrationFormSection/HubspotRegistrationFormSection';
import {ResultsHeroSection} from '../../features/b2bResults/ResultsHeroSection/ResultsHeroSection';
import {usePosthogABTest} from '../../hooks/usePosthogABTest';
import {CultureTypeResponse} from '../../types/B2B/B2BTypes';

export const B2BResultsPage = () => {
  const {state} = useLocation();
  const results = state as CultureTypeResponse | null;
  const {variant: registrationFormWidgetVariant} = usePosthogABTest<'control' | 'registration_form_widget'>({
    featureFlagKey: 'registration-form-widget',
    defaultVariant: false,
  });

  useEffect(() => {
    window.scrollTo({top: 0});
  }, []);

  if (!results) {
    return <Navigate to='/b2b' replace />;
  }

  const cultureHeroData = {
    cultureTypeTitle: results.cultureTypeTitle,
    cultureTypeText: results.cultureTypeText,
    cultureTypeImageUrl: results.cultureTypeUrl,
  };

  const culturePillars = results.culturePillars;
  const compatibleTalents = results.talentMatchStats.slice(0, 2);
  const isRegistrationFormWidgetEnabled =
    registrationFormWidgetVariant === true ||
    (typeof registrationFormWidgetVariant === 'string' && registrationFormWidgetVariant !== 'control');

  return (
    <Grid width='100%' borderRadius='5px'>
      <ResultsHeroSection {...cultureHeroData} />
      <CultureDimensionsSection culturePillars={culturePillars} />
      <CompatibleTalentsSection talentMatchStats={compatibleTalents} cultureTypeImageUrl={results.cultureTypeUrl} />
      {isRegistrationFormWidgetEnabled ? <HubspotRegistrationFormSection /> : <HubspotCalendarSection />}
      <CopyrightLink sx={{mt: 4, textAlign: 'center'}} />
    </Grid>
  );
};
